import { combineReducers } from 'redux';

import errors from './errors';
import categories from './categories';
import links from './links';


export default combineReducers({
  errors,
  categories,
  links,
});
